import moment from "moment";
import { CreditReportPersonalData } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

import { SsnDisplay } from "shared/components/SsnDisplay";
import { Show } from "shared/components/helpers/Show";
import { EMPTY_VALUE } from "views/applications-id-report/utils/constants";

interface PersonalDataProps {
  applicationId: string;
  applicantId: string;
  verificationId: string;
  personal_data?: CreditReportPersonalData;
  providedSSN?: string;
  ssnMismatched?: boolean;
  isNoHit: boolean;
  isSIN?: boolean;
}

// A bureau that has no tax id on file still returns a mask made of zeros, which
// reads as real data. Treat it as absent.
const getMaskedTaxId = (taxId?: string | null) => {
  if (!taxId) return undefined;

  return taxId.replace(/\D/g, "").replace(/0/g, "") === "" ? undefined : taxId;
};

export const PersonalData = ({
  applicationId,
  applicantId,
  verificationId,
  personal_data,
  isNoHit,
  isSIN
}: PersonalDataProps) => {
  const maskedTaxId = getMaskedTaxId(
    isSIN ? personal_data?.sin : personal_data?.ssn
  );

  if (isNoHit)
    return (
      <Section sectionTitle="Credit bureau response" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Credit bureau response" maxWidth="none">
      <div className="flex w-full flex-row flex-wrap">
        <div className="flex w-full flex-col gap-3">
          <Row title="Full name" value={personal_data?.full_name} />
          <Row
            title={isSIN ? "SIN" : "SSN"}
            value={
              <SsnDisplay
                displayValue={(data) =>
                  (isSIN
                    ? data.metadata?.personal_data?.sin
                    : data.metadata?.personal_data?.ssn) || undefined
                }
                applicationId={applicationId}
                applicantId={applicantId}
                verificationId={verificationId}
                maskedSsn={maskedTaxId || EMPTY_VALUE}
              />
            }
          />
          <Row
            title="File pulled"
            value={
              personal_data?.file_pulled &&
              moment(personal_data.file_pulled).isValid() &&
              moment(personal_data.file_pulled).format("MMM DD, YYYY")
            }
          />
          <Show if={!isSIN}>
            <Row
              title="User ID/Member number"
              value={personal_data?.customer_number}
            />
          </Show>
          <Row
            title="Date of birth"
            value={
              personal_data?.dob &&
              moment(personal_data.dob).isValid() &&
              moment(personal_data.dob).format("MMM DD, YYYY")
            }
          />
        </div>
      </div>
    </Section>
  );
};
